<script setup>
import { computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import { useConfig } from 'dashboard/composables/useConfig';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const router = useRouter();
const { accountId, currentAccount, accountScopedRoute } = useAccount();
const { isEnterprise } = useConfig();
const isFeatureEnabled = useMapGetter('accounts/isFeatureEnabledonAccount');

// Enterprise keeps its existing page access. In Community, wait for the account
// before mounting a board or settings page, including direct URLs and cold reloads.
const canAccess = computed(
  () =>
    isEnterprise ||
    (!!currentAccount.value.id &&
      isFeatureEnabled.value(accountId.value, FEATURE_FLAGS.KANBAN))
);

watch(
  [() => currentAccount.value.id, canAccess],
  ([loadedId, allowed]) => {
    if (loadedId && !allowed) router.replace(accountScopedRoute('home'));
  },
  { immediate: true }
);
</script>

<template>
  <RouterView v-slot="{ Component }">
    <component :is="Component" v-if="canAccess" :key="accountId" />
  </RouterView>
</template>
